import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agent-dashboard'),
    name: 'agent_dashboard',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: () => import('./AgentDashboard.vue'),
  },
];
